// extracted by mini-css-extract-plugin
export default {"button":"SponsorButton_button__FeEOz","left":"SponsorButton_left__jft0k"};